function headerMenuDropdown() {
  var dropdownTrigger = document.querySelectorAll('.header-dropdown__trigger');

  if (!dropdownTrigger[0]) {
    return;
  }

  dropdownTrigger.forEach(function (trigger, index) {
    trigger.addEventListener('click', function () {
      var parent = this.parentNode;
      var dropdownTriggerHeight = this.offsetHeight;
      var dropdownBody = parent.querySelector('.header-dropdown__body');
      var dropdownBodyHeight = dropdownBody.offsetHeight;

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        parent.style.height = dropdownTriggerHeight + 'px';
      } else {
        parent.classList.add('active');
        parent.style.height = dropdownBodyHeight + dropdownTriggerHeight + 'px';
      }
    });
  });
}

function hoverDropdownOpen() {
  var dropdownMenu = document.querySelectorAll('header-menu details');
  if (!dropdownMenu[0]) {
    return;
  }
  dropdownMenu.forEach(function (menu) {
    menu.addEventListener('mouseover', function () {
      this.setAttribute('open', '');
    });
    var debounceTimeout;
    menu.addEventListener('mouseleave', function () {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        this.removeAttribute('open');
      }, 1);
    });
  });
}

// function showReviewAvgRating() {
//   var reviewRating = document.querySelectorAll('.card__review');
//   if (!reviewRating[0]) {
//     return;
//   }

//   reviewRating.forEach(function (rating) {
//     var ratingValue = rating.querySelector('.jdgm-prev-badge__stars').getAttribute('data-score');
//     if (!rating && !ratingValue) {
//       return;
//     }

//     var avgRatingElm = document.createElement('span');
//     var ratingWrapper = rating.querySelector('.jdgm-prev-badge');
//     var ratingSibling = rating.querySelector('.jdgm-prev-badge__text');
//     avgRatingElm.classList.add('review-rating__avg');
//     avgRatingElm.innerHTML = ratingValue;

//     ratingWrapper.insertBefore(avgRatingElm, ratingSibling);
//   });
// }

function toggleReadmoreDescription() {
  var readmoreBtn = document.querySelectorAll('.product__description-toggle');
  var readlessBtn = document.querySelectorAll('.product__description-close');

  if (readmoreBtn[0]) {
    readmoreBtn.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var description = btn.closest('.product__description');
        description.classList.toggle('show');
      });
    });
  }

  if (readlessBtn[0]) {
    readlessBtn.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var description = btn.closest('.product__description');
        description.classList.toggle('show');
      });
    });
  }
}

function liveVisitorCount() {
  var visitorCount = document.querySelector('.product__visitor');
  if (!visitorCount) {
    return;
  }

  var visitorCountLabel = visitorCount.querySelector('.product__visitor-label .counter');
  var count = getRandomNumber(6, 25);
  visitorCountLabel.innerText = count;

  setInterval(() => {
    count = getRandomNumber(6, 25);
    visitorCountLabel.innerText = count;
  }, 30000);

  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}

function calculateEstimateShippping() {
  var shippingInput = document.querySelector('.cart-shipping__input input');

  if (!shippingInput) {
    return;
  }
  // listen to enter and value change event
  shippingInput.addEventListener('input', function () {
    var shippingValue = shippingInput.value;
    if (shippingValue !== '' && shippingValue.length > 4) {
      shippingInput.parentElement.classList.add('active');
    }
  });
  shippingInput.addEventListener('keypress', function (e) {
    var shippingValue = shippingInput.value;
    if (shippingValue !== '' && shippingValue.length > 4) {
      shippingInput.parentElement.classList.add('active');
    }
  });
}

function closeMenuDrawer() {
  var closeButton = document.querySelector('.menu-drawer .header__icon-close');
  if (!closeButton) {
    return;
  }

  closeButton.addEventListener('click', function () {
    document.body.classList.forEach(function (className) {
      if (className.startsWith('overflow-hidden-')) {
        document.body.classList.remove(className);
      }
    });
  });
}

function closeUtilityBar() {
  var closeButton = document.querySelector('.utility-bar__close');
  if (!closeButton) {
    return;
  }

  closeButton.addEventListener('click', function () {
    var utilityBar = document.querySelector('.utility-bar');
    utilityBar.style.display = 'none';
  });
}

function toggleProductIncluded() {
  var productIncludesOptions = document.querySelectorAll('.product__included-option');
  var productIncludes = document.querySelectorAll('.product__included-list-wrapper');
  if (!productIncludesOptions[0]) {
    return;
  }

  var optionsRow = document.querySelector('.product__included-options');

  // Scroll the active pill near the left edge of the row, but not flush
  // against it — leaving a peek of the previous pill hints there's more to
  // the left. The first pill has nothing before it, so it sits at 0
  // naturally; the last pill scrolls all the way to the end so it's flush
  // right with no further scroll room.
  function scrollActiveIntoView(activeOption) {
    if (!optionsRow) return;
    var maxScrollLeft = optionsRow.scrollWidth - optionsRow.clientWidth;
    if (maxScrollLeft <= 0) return;

    var isFirst = activeOption === productIncludesOptions[0];
    var isLast = activeOption === productIncludesOptions[productIncludesOptions.length - 1];

    var target;
    if (isFirst) {
      target = 0;
    } else if (isLast) {
      target = maxScrollLeft;
    } else {
      // Position relative to the scroll container's content, via viewport
      // rects rather than offsetLeft — offsetLeft is relative to the
      // nearest *positioned* ancestor, which isn't necessarily this flex
      // row, so it can't be trusted here.
      var peek = 24;
      var contentLeft = activeOption.getBoundingClientRect().left - optionsRow.getBoundingClientRect().left + optionsRow.scrollLeft;
      target = contentLeft - peek;
    }

    target = Math.max(0, Math.min(target, maxScrollLeft));
    optionsRow.scrollTo({ left: target, behavior: 'smooth' });
  }

  productIncludesOptions.forEach(function (option) {
    option.addEventListener('click', function () {
      var variantTarget = option.getAttribute('data-target');
      var variantTargetElm = document.querySelector(
        '.product__included-list-wrapper[data-variant="' + variantTarget + '"]'
      );

      if (!variantTargetElm) {
        return;
      }

      productIncludesOptions.forEach(function (option) {
        option.classList.remove('active');
      });

      productIncludes.forEach(function (include) {
        include.classList.remove('show');
      });

      option.classList.add('active');
      variantTargetElm.classList.add('show');
      scrollActiveIntoView(option);
    });
  });
}

function customerFormPopup() {
  var openButton   = document.querySelector('.header-account-button');
  var closeButton  = document.querySelector('.customer-form__close');
  var customerForm = document.querySelector('.customer-form__wrapper');
  if (!openButton || !closeButton || !customerForm) return;

  var viewLogin    = customerForm.querySelector('.customer.login');
  var viewRegister = customerForm.querySelector('.customer.register');

  var hRecover = customerForm.querySelector('#recover');
  var hLogin   = customerForm.querySelector('#login');
  var boxRecover = hRecover ? hRecover.nextElementSibling : null; // div setelah <p id="recover">
  var boxLogin   = hLogin   ? hLogin.nextElementSibling   : null; // div setelah <p id="login">

  function setShown(el, shown) {
    if (!el) return;
    el.style.display = shown ? 'block' : 'none';
    if (shown) {
      el.removeAttribute('hidden');
      el.removeAttribute('aria-hidden');
    } else {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    }
  }

  function setView(mode) {
    if (mode === 'register') {
      setShown(viewRegister, true);
      setShown(viewLogin, false);
    } else {
      setShown(viewRegister, false);
      setShown(viewLogin, true);
      setShown(boxLogin,   mode === 'login');
      setShown(boxRecover, mode === 'recover');
    }
    var email = customerForm.querySelector('#CustomerEmail');
    if (mode === 'login' && email) { try { email.focus({ preventScroll: true }); } catch(e){} }
  }

  function clearHash() {
    if (location.hash) {
      if ('replaceState' in history) history.replaceState(null, '', location.pathname + location.search);
      else location.hash = '';
    }
  }

  openButton.addEventListener('click', function () {
    document.body.classList.add('show-customer-form');
    setView('login');           
    clearHash();               
  });

  closeButton.addEventListener('click', function () {
    document.body.classList.remove('show-customer-form');
    clearHash();
  });

  customerForm.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var h = a.getAttribute('href');
    if (h === '#register') {
      e.preventDefault();
      setView('register');
      if ('replaceState' in history) history.replaceState(null, '', '#register');
      else location.hash = '#register';
    } else if (h === '#recover') {
      e.preventDefault();
      setView('recover');
      if ('replaceState' in history) history.replaceState(null, '', '#recover');
      else location.hash = '#recover';
    } else if (h === '#login') {
      e.preventDefault();
      setView('login');
      if ('replaceState' in history) history.replaceState(null, '', '#login');
      else location.hash = '#login';
    }
  });

  window.addEventListener('hashchange', function () {
    if (!document.body.classList.contains('show-customer-form')) return;
    if (location.hash === '#register') setView('register');
    else if (location.hash === '#recover') setView('recover');
    else setView('login');
  });

  if (document.body.classList.contains('show-customer-form')) {
    setView('login');
    clearHash();
  }
}

function togglePasswordInput() {
  var togglePasswordButtons = document.querySelectorAll('.toggle-password');
  if (!togglePasswordButtons[0]) {
    return;
  }

  togglePasswordButtons.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var inputElm = toggle.parentElement.querySelector('input');
      var inputCondition = toggle.getAttribute('data-value');

      if (inputCondition === 'show') {
        inputElm.setAttribute('type', 'text');
        toggle.setAttribute('data-value', 'close');
      } else if (inputCondition === 'close') {
        inputElm.setAttribute('type', 'password');
        toggle.setAttribute('data-value', 'show');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  headerMenuDropdown();
  hoverDropdownOpen();
  toggleReadmoreDescription();
  liveVisitorCount();
  calculateEstimateShippping();
  closeMenuDrawer();
  closeUtilityBar();

  toggleProductIncluded();
  togglePasswordInput();
  customerFormPopup();
});

// window.addEventListener('resize', function () {
//   if (this.window.innerWidth < 992) {
//     footerMenuDropdown();
//   }
// });
